// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1ehZ_","title":"Images45_title__30QlM","images":"Images45_images__egLvo"};